import React from 'react'

import loader from 'src/hoc/loader'
import NotFound from 'src/components/Errors/NotFound'

import { actionClearData, fetchSpaceGroupById } from './store'
import Form from './Form'

const getData = async ({ id }, dispatch) => {
  if (!id) {
    return
  }

  await dispatch(fetchSpaceGroupById(id))
}

const options = {
  Custom404: (
    <NotFound
      title="Space Group Not Found"
      message="The space group you are looking for cannot be found."
    />
  ),
  extractProps: ({ params }) => params,
  shouldRefresh: ({ id: previousId }, { id }) => previousId !== id,
  onUnmount: dispatch => dispatch(actionClearData()),
}

export default loader(getData, options)(Form)
